import React from "react";
import CheckoutComponent from "../components/Checkout";

const Checkout = () => {
  return <CheckoutComponent />;
};

export default Checkout;
